import React from 'react';
import { Clock, MapPin, Phone, Navigation } from 'lucide-react';
import { shopInfo } from '../../mock';
import { Button } from '../ui/button';

export const HoursSection = () => {
  const openMaps = () => {
    const address = encodeURIComponent(shopInfo.address.fullAddress);
    window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, '_blank');
  };

  return (
    <section id="hours" className="py-20 bg-rose-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-stone-900 mb-4">
            Visit Us
          </h2>
          <p className="text-lg text-stone-600 max-w-2xl mx-auto">
            Stop by during our business hours or call to schedule an appointment
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Hours Card */}
          <div className="bg-white rounded-2xl p-8 border-2 border-stone-200 hover:border-maroon-700 transition-all duration-300 shadow-lg">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-maroon-100 p-3 rounded-lg">
                <Clock className="h-6 w-6 text-maroon-800" />
              </div>
              <h3 className="text-2xl font-bold text-stone-900">Hours of Operation</h3>
            </div>

            <div className="space-y-3">
              {shopInfo.hoursOfOperation.map((day, index) => (
                <div
                  key={index}
                  className="flex items-center justify-between py-3 border-b border-stone-200 last:border-b-0"
                >
                  <span className="text-stone-700 font-medium">{day.day}</span>
                  <span className={`font-semibold ${
                    day.hours === 'Closed' ? 'text-stone-400' : 'text-maroon-800'
                  }`}>
                    {day.hours}
                  </span>
                </div>
              ))}
            </div>

            <div className="mt-6 p-4 bg-rose-50 rounded-lg border border-rose-200">
              <p className="text-sm text-stone-700">
                <span className="font-semibold">Note:</span> Hours may vary on holidays. Please call ahead to confirm.
              </p>
            </div>
          </div>

          {/* Location Card */}
          <div className="bg-white rounded-2xl p-8 border-2 border-stone-200 hover:border-maroon-700 transition-all duration-300 shadow-lg">
            <div className="flex items-center space-x-3 mb-6">
              <div className="bg-maroon-100 p-3 rounded-lg">
                <MapPin className="h-6 w-6 text-maroon-800" />
              </div>
              <h3 className="text-2xl font-bold text-stone-900">Location</h3>
            </div>

            <div className="space-y-6">
              <div>
                <p className="text-stone-600 text-sm mb-2">Address</p>
                <p className="text-lg text-stone-900 font-medium">
                  {shopInfo.address.street}
                </p>
                <p className="text-lg text-stone-900 font-medium">
                  {shopInfo.address.city}, {shopInfo.address.state} {shopInfo.address.zip}
                </p>
              </div>

              <div>
                <p className="text-stone-600 text-sm mb-2">Phone</p>
                <a
                  href={`tel:${shopInfo.phone}`}
                  className="text-lg text-maroon-800 font-semibold hover:text-maroon-900 flex items-center space-x-2 transition-colors duration-200"
                >
                  <Phone className="h-5 w-5" />
                  <span>{shopInfo.phone}</span>
                </a>
              </div>

              <div>
                <p className="text-stone-600 text-sm mb-3">Near</p>
                <p className="text-stone-700">
                  Located near the Starkville Public Library, easily accessible from Mississippi State University campus.
                </p>
              </div>

              <Button
                onClick={openMaps}
                className="w-full bg-maroon-800 hover:bg-maroon-900 text-stone-100 transition-colors duration-200"
                size="lg"
              >
                <Navigation className="h-5 w-5 mr-2" />
                Get Directions
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
